import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import cx from 'classnames';
import NavCard from '../NavigationCard';
import { CONSTANTS } from '../../constants/Constants';
import './style.scss';
const LeftNavPinnedCards = props => {
  const {
    favPinnedCards,
    handleCardNavigation,
    inlineCollapsed,
    modules,
    pinFavoriteCards,
    apiBaseUrl,
    activeCard
  } = props;
  const [cards, setCards] = React.useState(favPinnedCards);
  React.useEffect(() => {
    setCards(favPinnedCards);
  }, [favPinnedCards]);
  const handleDragEnd = result => {
    let payload = [];
    const items = Array.from(cards);
    const [reorderItem] = items.splice(result.source.index, 1);
    if (!result.destination) {
      payload = items;
      setCards(items);
    } else {
      items.splice(result.destination.index, 0, reorderItem);
      payload = items;
      setCards(items);
    }
    payload = payload.map((item, index) => ({
      appKey: item.appKey,
      pinOrder: index
    }));
    pinFavoriteCards(payload, apiBaseUrl);
  };
  return /*#__PURE__*/React.createElement(DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React.createElement(Droppable, {
    droppableId: "favCards"
  }, droppableProvided => /*#__PURE__*/React.createElement("ul", _extends({
    className: "menu-list ".concat(inlineCollapsed ? 'menu-inline-collapsed menu-vertical' : 'menu-inline'),
    ref: droppableProvided.innerRef
  }, droppableProvided.droppableProps), inlineCollapsed && activeCard && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "fav-card-submenu fav-card-selected-unpinned",
    role: "menuitem"
  }, /*#__PURE__*/React.createElement(NavCard, {
    modules: modules,
    card: activeCard,
    label: activeCard.slabel
  })), cards.length > 0 && /*#__PURE__*/React.createElement("hr", {
    className: "pinned-card-splitter"
  })), cards && cards.map((card, index) => {
    const isSelected = (activeCard === null || activeCard === void 0 ? void 0 : activeCard.path) === card.path;
    return /*#__PURE__*/React.createElement(Draggable, {
      key: card.appKey,
      draggableId: card.appKey,
      index: index
    }, (draggableProvided, snapshot) => /*#__PURE__*/React.createElement("li", _extends({
      ref: draggableProvided.innerRef
    }, draggableProvided.draggableProps, draggableProvided.dragHandleProps, {
      onClick: handleCardNavigation(card),
      className: cx('fav-card-submenu', {
        'onDrag': snapshot.isDragging,
        'fav-card-submenu-selected': isSelected
      }),
      role: "menuitem",
      title: card.label
    }), /*#__PURE__*/React.createElement(NavCard, {
      modules: modules,
      card: card,
      label: card.slabel
    }), /*#__PURE__*/React.createElement("span", {
      className: "icon-drag-and-drop drag-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "onDragPlaceholder",
      style: {
        display: snapshot.isDragging ? 'flex' : 'none'
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "dropMessage"
    }, __('Drop Right to Unpin')), /*#__PURE__*/React.createElement("span", {
      id: "drag-icon",
      className: "icon-pin drag-icon-pin"
    }))));
  }), droppableProvided.placeholder)));
};
LeftNavPinnedCards.propTypes = {
  modules: PropTypes.array.isRequired,
  handleCardNavigation: PropTypes.func.isRequired,
  favPinnedCards: PropTypes.array.isRequired,
  inlineCollapsed: PropTypes.bool.isRequired,
  apiBaseUrl: PropTypes.string.isRequired,
  pinFavoriteCards: PropTypes.func.isRequired
};
export default LeftNavPinnedCards;